import React, { useEffect } from 'react';
import TagManagerService from 'services/TagManager';
import {HtmlParse} from 'utils';

const Icon404 = () => {

    useEffect(() => {
        TagManagerService.changePage();
        TagManagerService.emptyImpressions();
    },[])

    const icon = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="178" height="178" viewBox="0 0 178 178"><defs><path id="a" d="M0 0h178v178H0z"></path></defs><g fill="none" fill-rule="evenodd"><g><mask id="b" fill="#fff"><use xlink:href="#a"></use></mask><path fill="#F1F1F1" d="M178 89c0 49.153-39.847 89-89 89S0 138.153 0 89 39.847 0 89 0s89 39.847 89 89" mask="url(#b)"></path></g><g fill="#2F302F"><path d="M89.263 120.653c-6.267 0-11.365 5.097-11.365 11.362s5.098 11.362 11.365 11.362c6.265 0 11.362-5.097 11.362-11.362s-5.097-11.362-11.362-11.362m0 25.724c-7.92 0-14.365-6.443-14.365-14.362 0-7.919 6.444-14.362 14.365-14.362 7.92 0 14.362 6.443 14.362 14.362 0 7.92-6.443 14.362-14.362 14.362M84.243 106.428h9.516l6.72-71.806H77.521l6.721 71.806zm10.882 3H82.877a1.5 1.5 0 0 1-1.494-1.36l-7.002-74.806a1.505 1.505 0 0 1 1.494-1.64h26.25a1.5 1.5 0 0 1 1.493 1.64l-6.999 74.806a1.5 1.5 0 0 1-1.494 1.36z"></path></g></g></svg>`;

    return(
        <span >{HtmlParse(icon)}</span>
    )
}

export default Icon404;
